import React from "react";
import { View } from "react-native";
import Typography from "../../typography/Typography";
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import CustomHeader from "../../customHeader/CustomHeader";
import { Card } from "../../card/Card";
import { ListItem } from "../../listItem/ListItem";
const ContactUsPage = ({ backAction, triggerAction, height, isFromJupiter, openWhatsAppAction, openCallAction, openEmailAction, callNumber, whatsappNumber, emailId, showWA, showCall, showSupportPhoneNumber, showEmail }) => {
    const header = () => {
        return (React.createElement(View, null,
            React.createElement(CustomHeader, { goBackAction: backAction, triggerAction: triggerAction, title: "Contact us", id: "bt_contactUs_goBack", hideNeedHelp: true, 
                //@ts-ignore
                skipAndroidExit: true })));
    };
    const renderWhatsAppList = () => {
        return (React.createElement(ListItem, { title: "WhatsApp", subTitle: "", onPress: () => {
                openWhatsAppAction();
            }, customTitle: {
                label: "WhatsApp",
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                lineHeight: 20,
            }, customSubTitle: {
                label: 'We usually reply within 5-10 mins. We’re available on Mon-Sat from 9:30 AM to 6:30 PM',
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            }, id: "txt_contactUs_whatsApp", isDivider: false, rightIcon: true, leadIconName: IconTokens.Whatsapp }));
    };
    const renderCallList = () => {
        return (React.createElement(ListItem, { title: "Call", subTitle: "", onPress: () => {
                openCallAction();
            }, customTitle: {
                label: "Call",
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                lineHeight: 20,
            }, customSubTitle: {
                label: `Call us at ${callNumber}. We’re available on Mon-Sat from 9:30 AM to 6:30 PM`,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            }, id: "txt_contactUs_call", isDivider: false, rightIcon: true, leadIconName: IconTokens.Phone }));
    };
    const renderEmailList = () => {
        return (React.createElement(ListItem, { title: "Email", subTitle: `Email us at ${emailId}. We usually respond within 2 hours`, onPress: () => {
                openEmailAction();
            }, customTitle: {
                label: "Email",
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                lineHeight: 20,
            }, customSubTitle: {
                label: `Email us at ${emailId}. We usually respond within 2 hours`,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            }, id: "txt_contactUs_email", isDivider: false, rightIcon: true, leadIconName: IconTokens.Email }));
    };
    const renderWhatsAppCard = () => {
        return (React.createElement(Card, { needBorder: true, bgColor: ColorTokens.Primary_02, borderColor: ColorTokens.Primary_20, borderWidth: 1, borderRadius: BorderRadiusTokens.BR3, margin: {
                top: SizeTypeTokens.NONE,
                bottom: SizeTypeTokens.NONE
            }, body: {
                children: renderWhatsAppList()
            } }));
    };
    const renderCallCard = () => {
        return (React.createElement(Card, { needBorder: true, bgColor: ColorTokens.Primary_02, borderColor: ColorTokens.Primary_20, borderWidth: 1, borderRadius: BorderRadiusTokens.BR3, margin: {
                top: SizeTypeTokens.NONE,
                bottom: SizeTypeTokens.NONE
            }, body: {
                children: renderCallList()
            } }));
    };
    const renderEmailCard = () => {
        return (React.createElement(Card, { needBorder: true, bgColor: ColorTokens.Primary_02, borderColor: ColorTokens.Primary_20, borderWidth: 1, borderRadius: BorderRadiusTokens.BR3, margin: {
                top: SizeTypeTokens.NONE,
                bottom: SizeTypeTokens.XXXL
            }, body: {
                children: renderEmailList()
            } }));
    };
    const renderBody = () => {
        return (React.createElement(View, { style: { marginTop: 16, paddingHorizontal: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: "Reach out to us", color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 8, marginBottom: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: isFromJupiter ? "We would love to hear from you. You can get back to us via Call, Email." : "We would love to hear from you. You can get back to us via Call, Email or WhatsApp.", color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, null,
                showWA ? renderWhatsAppCard() : React.createElement(React.Fragment, null),
                showCall && showSupportPhoneNumber ? React.createElement(View, { style: { marginVertical: 16 } }, renderCallCard()) : React.createElement(View, { style: { marginTop: 16 } }),
                showEmail ? renderEmailCard() : React.createElement(React.Fragment, null))));
    };
    return (React.createElement(View, { style: { height: height } },
        header(),
        renderBody()));
};
export default ContactUsPage;
